/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Features_AlexpInputs */

const en_testimonial_features_alexp = /** @type {(inputs: Testimonial_Features_AlexpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This app is a MUST for anyone in academics. I've only had it for a couple of weeks and I'm already sold. I'm in grad school at the moment and almost all of our reading are academic articles. It takes me ages to get through them every week and by the end it feels like my eyes are going to fall out of my head.`)
};

const es_testimonial_features_alexp = /** @type {(inputs: Testimonial_Features_AlexpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta app es IMPRESCINDIBLE para cualquiera en el ámbito académico. Solo la he tenido un par de semanas y ya estoy convencido. Estoy en la escuela de posgrado en este momento y casi todas nuestras lecturas son artículos académicos. Me toma siglos revisarlos cada semana y al final siento que se me van a caer los ojos.`)
};

/**
* | output |
* | --- |
* | "This app is a MUST for anyone in academics. I've only had it for a couple of weeks and I'm already sold. I'm in grad school at the moment and almost all of o..." |
*
* @param {Testimonial_Features_AlexpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_features_alexp = /** @type {((inputs?: Testimonial_Features_AlexpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Features_AlexpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_features_alexp(inputs)
	return en_testimonial_features_alexp(inputs)
});